export const PAGE_SIZE = 20;
export const DEFAULT_POSITION = {
  lat: 35.6812327857386,
  lng: 139.767154693604,
};
